import { Observable } from "../common/observable";
import { CHARTMATRIX_SQUARE } from "./chartmatrix";
import "./clock-element.css";

class ClockElement extends HTMLElement {
    #timeId?: number;
    $time = new Observable<Date>(new Date());
    $chars = new Observable<string[]>([]);
    #prevChars: string[] = [];

    constructor() {
        super();
    }

    connectedCallback() {
        this.innerHTML = "";

        const wrapper = document.createElement("div");
        wrapper.className = "wrapper";
        const container = document.createElement("div");
        container.className = "container";

        wrapper.appendChild(container);
        this.appendChild(wrapper);

        this.$time.subscribe((time) => {
            const hours = time.getHours().toString();
            const minutes = time.getMinutes().toString();
            const seconds = time.getSeconds().toString();

            const firstHourChar = hours.length < 2 ? "0" : hours[0];
            const secondHourChar = hours.length < 2 ? hours[0] : hours[1];

            const firstMinuteChar = minutes.length < 2 ? "0" : minutes[0];
            const secondMinuteChar =
                minutes.length < 2 ? minutes[0] : minutes[1];

            const firstSecondChar = seconds.length < 2 ? "0" : seconds[0];
            const secondSecondChar =
                seconds.length < 2 ? seconds[0] : seconds[1];

            this.$chars.broadcast([
                firstHourChar,
                secondHourChar,
                ":",
                firstMinuteChar,
                secondMinuteChar,
                ":",
                firstSecondChar,
                secondSecondChar,
            ]);
        }, true);

        this.$chars.subscribe((chars) => {
            chars.forEach((char, charIndex) => {
                if (char === this.#prevChars[charIndex]) return;

                const charMatrix = CHARTMATRIX_SQUARE[char] || [];
                const charMatrixElement = document.createElement("div");
                charMatrixElement.className = "charMatrix";

                charMatrix.flat().forEach((item, index) => {
                    const matrixItemElement = document.createElement("div");
                    matrixItemElement.className = "matrixItem";
                    matrixItemElement.style.animationDelay = `${index * 10}ms`;

                    const drawItemElement = document.createElement("div");
                    drawItemElement.classList.add("drawItem");
                    if (!!item) drawItemElement.classList.add("on");

                    matrixItemElement.appendChild(drawItemElement);
                    charMatrixElement.appendChild(matrixItemElement);
                });

                const existing = container.children[charIndex];
                if (existing) {
                    existing.replaceWith(charMatrixElement);
                } else {
                    container.appendChild(charMatrixElement);
                }
            });

            this.#prevChars = chars;
        }, true);

        this.#timeId = setInterval(() => {
            this.$time.broadcast(new Date());
        }, 1000);
    }

    disconnectedCallback() {
        clearInterval(this.#timeId);
        this.$time.unsubscribeAll();
        this.$chars.unsubscribeAll();
    }
}

customElements.define("pos-clock", ClockElement);
